const investTagAssetClassLang = {
	mixte: {
		tag: 'invest.tag.asset_class.mixte',
		fr: 'Diversifié',
		en: 'Multi-asset',
	},
	action: {
		tag: 'invest.tag.asset_class.action',
		fr: 'Action',
		en: 'Equities',
	},
	obligation: {
		tag: 'invest.tag.asset_class.obligation',
		fr: 'Obligation',
		en: 'Fixed income',
	},
};

export default investTagAssetClassLang;
